
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/explore_collection",
      function () {
        return require("private-next-pages/collection/explore_collection.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/explore_collection"])
      });
    }
  